var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"President-main"},[_c('div',{staticClass:"content"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.content.Title))]),_c('div',{staticClass:"body",domProps:{"innerHTML":_vm._s(_vm.content.Body)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }